module.exports = __webpack_public_path__ + "static/37-thumb-da2b35ca8787c27c1a9a5d65af370b23.jpg";